import { useAtomValue } from "jotai";
import { userAtom } from "../utils/store";
import { Navigate, useLocation } from "react-router-dom";
import apiCall from "../utils/apiCall";
import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";

interface ComponentProp {
  children: JSX.Element;
}

const ProtectedRoute = ({ children }: ComponentProp) => {
  const user = useAtomValue(userAtom);
  const location = useLocation();

  const getAllRolePermission = async () => {
    //Evoting action type is 4
    const url = `/MembershipSetUp/member/GetAllRolePermission?actionType=${4}`;
    return await apiCall().get(url);
  };

  const { data, isLoading, error } = useQuery({
    queryKey: ["get-AllRolePermission"],
    queryFn: getAllRolePermission,
    refetchOnWindowFocus: false,
    retry: 0,
    enabled: true,
  });

  // Extract role permission data
  const rolePermissionData = data?.data?.Data || [];
  const rolePermissionDataError = error as AxiosError;

  const routePermissions: Record<string, string[]> = rolePermissionData?.reduce(
    (acc: Record<string, string[]>, item: any) => {
      if (!acc[item?.PathName]) {
        acc[item?.PathName] = [];
      }
      acc[item?.PathName]?.push(item?.RoleName);
      return acc;
    },
    {}
  );

  // console.log(routePermissions, "routePermissions");

  const userRoleNames = user?.RoleNames || [];
  const allowedRoles = routePermissions[location.pathname] || [];
  const hasAccess =
    allowedRoles.length === 0 ||
    userRoleNames?.some((role) => allowedRoles.includes(role));

  // console.log(hasAccess, "hasAccess");

  if (isLoading) return <p>Loading...</p>;
  return user?.Token && hasAccess ? (
    children
  ) : (
    <Navigate to="/" state={{ from: location }} replace={true} />
  );
};

export default ProtectedRoute;
